import Container from "../core/Container"
import Heading from "../core/Heading"
import Paragraph from "../core/Paragraph"
import Button from "../core/Button"

export default function SubscribeUs({ onSubmit }) {
  return(
    <section id="odber_newsletteru">
    <Container bgColor="transparent" className="relative w-full py-16 md:py-10 overflow-hidden bg-gradient-to-br from-main via-main_dark to-main_light">
        {/* Dekorativní „bloby“ pro hloubku */}
        <Container bgColor="transparent" className="absolute inset-0 pointer-events-none" aria-hidden="true">
          <Container bgColor="transparent" className="absolute -top-20 -right-20 w-72 h-72 md:w-96 md:h-96 rounded-full bg-white/10 blur-3xl" />
          <Container bgColor="transparent" className="absolute -bottom-20 -left-20 w-64 h-64 md:w-80 md:h-80 rounded-full bg-main_light/40 blur-3xl" />
          <Container bgColor="transparent" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 md:w-[28rem] md:h-[28rem] rounded-full bg-second_light/20 blur-3xl" />
        </Container>
        <Container bgColor="transparent" className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Container className="text-center mb-8" bgColor="transparent">
                <Heading variant="h2" color="white" className="mb-4">📨 Přihlaste se k odběru našeho newsletteru</Heading>
                <Paragraph variant="lead" color="white" className="mb-6">Přihlaste se k odběru našeho newsletteru a dostávejte novinky a informace o našich akcích.</Paragraph>
            </Container>
            
            <form onSubmit={onSubmit} action="#" method="POST" className="space-y-4">
                <Container className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center" bgColor="transparent">
                    <Container className="flex-1" bgColor="transparent">
                        <label htmlFor="email" className="sr-only">Email</label>
                        <input 
                            id="email" 
                            type="email" 
                            name="email" 
                            autoComplete="email" 
                            required 
                            placeholder="Váš email"
                            className="w-full bg-white border-2 border-gray-300 rounded-xl py-3 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transition-all duration-300 text-gray-900 placeholder-gray-500"
                        />
                    </Container>
                    <Button type="submit" variant="primary-white">Přihlásit se</Button>
                </Container>
                
                <p className="text-white text-xs sm:text-sm text-center">
                    Detaily o odběru newsletteru naleznete v{" "}
                    <a 
                        href="/podminky_zpracovani" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="text-blue-400 hover:text-blue-300 underline transition-colors"
                    >
                        zásadách zpracování osobních údajů
                    </a>
                </p>
            </form>
        </Container>
    </Container>
    </section>
  )
}